import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs";
import { WebStorage } from "../services/web-storage";

export const translateLanguageResolver = () => {
  const translate = inject(TranslateService);
  const webStorage = inject(WebStorage);

  // The active UI language is the profile selection, surfaced via
  // WebStorage.uiLanguage (backed by the shared userContextStore). PIA's own
  // localStorage / navigator language detection and the public /i18n existence
  // check were removed during the integration into poff-frontend.
  const language = webStorage.uiLanguage;

  translate.setDefaultLang(language);

  return translate.use(language).pipe(map(() => language));
};
